import React from 'react';
import { motion } from 'framer-motion';

// Mini-etape "choix de langue" presentee en amont de la sequence d'onboarding.
// Extrait du STEP_SETUP historique pour decongestionner le flow.
export default function LanguageStep({ language = 'fr', onChoose }) {
  const handleChoose = (lang) => {
    if (typeof onChoose === 'function') {
      onChoose(lang);
    }
  };

  return (
    <div className="cb-min-h-screen bg-[color:var(--cb-bg)] flex flex-col gradient-peach-wash">
      <div className="flex-1 flex flex-col justify-center px-6 max-w-md mx-auto w-full">
        <p className="cozy-section-kicker mb-1 text-center">
          {language === 'fr' ? 'Bienvenue sur ColoBongo' : 'Welcome to ColoBongo'}
        </p>
        <h1 className="text-2xl font-extrabold text-[color:var(--cb-text)] mb-2 text-center">
          {language === 'fr' ? 'Choisis ta langue' : 'Choose your language'}
        </h1>
        <p className="text-sm text-[color:var(--cb-text-muted)] mb-7 text-center">
          {language === 'fr'
            ? 'Choisis ta langue pour personnaliser tout ton parcours.'
            : 'Choose your language to personalize your whole journey.'}
        </p>
        <div className="flex gap-3" data-testid="language-step-toggle">
          {['en', 'fr'].map((lang) => (
            <motion.button
              key={lang}
              type="button"
              onClick={() => handleChoose(lang)}
              className={`flex-1 py-3 rounded-[18px] font-semibold border-2 transition-colors ${
                language === lang
                  ? 'bg-[color:var(--cb-primary)] text-white border-[color:var(--cb-primary)]'
                  : 'bg-white text-[color:var(--cb-text)] border-[rgba(61,61,61,0.12)]'
              }`}
              whileTap={{ scale: 0.97 }}
              aria-label={lang === 'en' ? 'English' : 'Francais'}
            >
              {lang === 'en' ? 'English' : 'Francais'}
            </motion.button>
          ))}
        </div>
      </div>
    </div>
  );
}
